export default __webpack_public_path__ + "media/zurb/img/home/SAP-e22d9aae6a48b0e426aa400bf44ea303.svg";